const character = (optionNumber) => {
  const char = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];
  return char[optionNumber];
};

module.exports = { character };
